import React, { useEffect } from "react"
import { Link, navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { ChevronRightIcon } from "components/Icons"
import Layout from "components/Layout"
import NotificationsList from "components/NotificationsList"
import useDesignerUser from "hooks/useDesignerUser"
import useNotifications from "hooks/useNotifications"
import OnboardingSteps from "components/OnboardingSteps"
import { PRODUCT_LIST_OVERVIEW_URL } from "constants/urls"
import useFlashMessages from "hooks/useFlashMessages"
import Show from "components/Show"
import FlashMessageList from "components/FlashMessageList"

const HomePage = () => {
  const { designerUser } = useDesignerUser()
  const { data: notificationData } = useNotifications()
  const { data: flashMessageData } = useFlashMessages()
  const notifications = notificationData?.results.slice(0, 5)
  const messages = flashMessageData?.results
    .filter(message => message.displayType === `note` && !message.dismissed)
    .slice(0, 5)

  useEffect(() => {
    if (designerUser && !designerUser.designer.defaultToBetaDashboardHomepage) {
      // Disable the home and just navigate to products
      navigate(PRODUCT_LIST_OVERVIEW_URL, { replace: true })
    }
  }, [designerUser])

  return (
    <Layout title="Home">
      <div className="grid gap-4 md:gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <header className="p-6 mb-6 flex justify-between items-center bg-primary-lightest-gray border border-primary-light-gray rounded-lg">
            <div>
              <h1 data-testid="greetings-brand-name" className="heading-2 mb-4">
                Hello, {designerUser?.designer.name}!
              </h1>

              <p className="text-sm">
                Welcome to your new Wolf & Badger dashboard loaded with insights
                and tools to take your business to the next level.
              </p>
            </div>

            <div className="hidden h-24 w-40 flex-shrink-0 -mr-5 ml-4 lg:block">
              <StaticImage
                src="../images/welcome-chart.png"
                alt=""
                role="presentation"
                placeholder="none"
                quality={100}
                height={96}
              />
            </div>
          </header>

          <Show when={messages?.length}>
            <h2 className="heading-4 mb-4" data-testid="messages">
              Messages
            </h2>

            <FlashMessageList messages={messages} />
          </Show>

          <div className="flex justify-between items-center mb-4">
            <h2 className="heading-4">Notifications</h2>

            <Link
              to="/notifications"
              className="flex items-center text-sm font-medium"
            >
              <span className="underline" data-testid="view-all-notification">
                View all notifications
              </span>
              <ChevronRightIcon className="w-4 h-4" aria-hidden="true" />
            </Link>
          </div>

          <NotificationsList notifications={notifications} />
        </div>

        <div className="col-span-1">
          <OnboardingSteps />
        </div>
      </div>
    </Layout>
  )
}

export default HomePage
